// extracted by mini-css-extract-plugin
export var messageSideLeft = "_ol-1";
export var stateContainer = "_ol-0";